import { type SyntheticEvent, type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import styles from './main.scss';

import { SIZES } from '../constants.ts';

type InputBorderContainerProps = {
    children: ReactNode;
    disabled?: boolean;
    hasError?: boolean;
    noBorder?: boolean;
    borderRounded?: boolean;
    isFocused?: boolean;
    maskForPrivacy?: boolean;
    onClick?: (e: SyntheticEvent<HTMLDivElement>) => void;
    size?: typeof SIZES.small | typeof SIZES.medium | typeof SIZES.mediumLarge | typeof SIZES.large;
};

export const InputBorderContainer: FC<InputBorderContainerProps> = ({
    children,
    disabled,
    hasError,
    isFocused,
    maskForPrivacy,
    onClick,
    size,
    noBorder,
    borderRounded,
}) => {
    const inputContainerClasses = classnames(styles.inputContainer, {
        [styles.heightDefault]: !size,
        [styles.heightSmall]: size === SIZES.small,
        [styles.heightMedium]: size === SIZES.medium,
        [styles.heightMediumLarge]: size === SIZES.mediumLarge,
        [styles.heightLarge]: size === SIZES.large,
        [styles.borderError]: hasError,
        [styles.borderFocus]: !hasError && isFocused,
        [styles.borderRounded]: borderRounded,
        [styles.noBorder]: noBorder && !hasError,
        [styles.disabled]: disabled,
        'fs-block': maskForPrivacy,
    });

    let containerProps = {};
    if (onClick) {
        containerProps = {
            onClick,
        };
    }
    return (
        <div className={inputContainerClasses} {...containerProps}>
            {children}
        </div>
    );
};
